import React from 'react';
import classnames from 'classnames';
import styles from './style.module.scss';

interface Props {
  /** 需要设置安全区域的方向 */
  directions?: Array<'top' | 'right' | 'bottom' | 'left'>;
}

export function SafeArea(props: Props) {
  const { directions = ['bottom'] } = props;

  const className = classnames(
    {
      [styles.top]: directions.includes('top'),
      [styles.right]: directions.includes('right'),
      [styles.bottom]: directions.includes('bottom'),
      [styles.left]: directions.includes('left'),
    },
    styles.root
  );

  return <div className={className} />;
}
